import React from 'react'
import { ButtonIconSeeker, AutocompleteAjaxSeeker, IconSeeker } from '@ui-seeker/core'
import { copyToClipboard } from '@ui-seeker/utils'
import { Box, Typography } from '@mui/material'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { LEADING_PRICE_ROUTES } from '@constants/routes'
import { formData, leadingOpenUrlModal, leadingUrlId } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals'
import { useLeadingDeleteUrl } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@hooks'
import { dsColorNew } from "@palette"
import { headerIconButtonSx } from "@components"


export default function LeadingAnalyzerActions() {
	const { showToast } = useToast()
	const { handleDeleteUrl } = useLeadingDeleteUrl()

	const onAjaxCommon = options => options.map(option => ({
		label: `${option.label}`,
		path: option.path,
		value: `${option.value}`,
	}))

	const encodeToBase64 = (obj) => {
		const jsonString = JSON.stringify(obj)
		const bytes = new TextEncoder().encode(jsonString)
		return btoa(String.fromCharCode(...bytes))
	}

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		 <ButtonIconSeeker
			icon="link"
			iconWeight="regular"
			tooltip="Copy filters link to clipboard"
			sx={headerIconButtonSx}
			onClick={() => {
				try {
					copyToClipboard(`rentacar.dataseekers.com${LEADING_PRICE_ROUTES.PATH}?sp=${encodeToBase64(formData.value)}`)
					showToast.success('Url copied to clipboard')
				} catch {
					showToast.error('Could not copy to clipboard')
				}
			}}
		/>

		 <ButtonIconSeeker
			icon="floppy-disk"
			iconWeight="regular"
			tooltip="Save filters link"
			sx={headerIconButtonSx}
			onClick={() => leadingOpenUrlModal.value = `${LEADING_PRICE_ROUTES.PATH}?sp=${encodeToBase64(formData.value)}`}
		/>

		 <AutocompleteAjaxSeeker
			filterSelectedOptions={false}
			sx={{ width: 180 }}
			inputProps={{ startAdornment: <IconSeeker icon="bookmark" iconWeight="regular" sx={{ fontSize: 13, color: dsColorNew.textMuted, ml: 0.5, mr: 0.25 }}/> }}
			value={leadingUrlId.value}
			urlAjax={`${BACKEND_APIS.DASHBOARD}/get-filters`}
			onAjax={onAjaxCommon}
			getOptionLabel={({ label }) => label || ''}
			formatOptionLabel={option => <LabelComponent {...option} handleDelete={handleDeleteUrl} />}
			onChange={(e) => {
				leadingUrlId.value = e.target.value
			}}
			filters={{
				urlId: leadingUrlId.value,
			}}
		/>
	</Box>
}


function LabelComponent({ label, value, path, handleDelete }) {
	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
		<Typography
			sx={{ width: '100%' }}
			onClick={() => {
				leadingUrlId.value = value
				window.open(path, '_blank')
			}}
		>{label}
		</Typography>
		<ButtonIconSeeker
			icon='trash-can'
			iconWeight="regular"
			sx={{ fontSize: 13, color: dsColorNew.textMuted, '& *': { color: 'inherit' }, '&:hover': { color: dsColorNew.dangerRed, backgroundColor: dsColorNew.dangerBg } }}
			tooltip='Delete this saved filter'
			onClick={() => handleDelete(value, label)}
		/>
	</Box>
}